import { Button, Divider, Form, Spin, Tag, BackTop, Switch } from 'antd';
import { useTranslation } from 'react-i18next';

import { useEffect, useState } from 'react';
import Sticky from 'react-sticky-el';
import parse from 'html-react-parser';
import GlobalService from '../../../../services/Global.service';
import classNames from 'classnames';
import { svgNoImage } from '../../PrivacyNotices/components/StepPreview';
import ModalConfirm from '../../../../components/Shared/modal/confirm';

export default function StepPreview({ ...props }) {
    const { t } = useTranslation(['translation', 'consent']);

    const [previewLang, setPreviewLang] = useState('TH');

    const [openConfirm, setOpenConfirm] = useState(false);

    const detail = props?.data;
    const hrPrivacyPolicy = detail?.hrPrivacyPolicy;
    const hrIntroductionLawfulBasis = detail?.hrIntroductionLawfulBasis;
    const hrPersonalDataCollect = detail?.hrPersonalDataCollect;
    const hrReasonCollectedData = detail?.hrReasonCollectedData;
    const hrTransferPersonalData = detail?.hrTransferPersonalData;
    const hrRetainPersonalData = detail?.hrRetainPersonalData;
    const hrDataSubjectRight = detail?.hrDataSubjectRight;
    const hrPolicyChange = detail?.hrPolicyChange;

    const [logo, setLogo] = useState('');

    const getNextVersion = () => {
        let item = '';
        let version = hrPrivacyPolicy?.latestPublishVersion;
        for (let index = 0; index <= 3; index++) {
            if (version?.split('.')[0][index] !== '0') {
                item = version
                    ?.split('.')[0]
                    ?.slice(index, version?.split('.')[0]?.length);
                break;
            }
        }
        item = String(Number(item) + 1);
        switch (item?.length) {
            case 1:
                item = '000'.concat(`${item}.0`);
                break;
            case 2:
                item = '00'.concat(`${item}.0`);
                break;
            case 3:
                item = '0'.concat(`${item}.0`);
                break;
            default:
                item = item.concat(`.0`);
                break;
        }
        return item;
    };

    const statusSwitch = (isPublished) => {
        return (
            <div className="flex items-center space-x-2 mt-1">
                <div
                    className={classNames(
                        'rounded-full w-max px-3 text-xs font-medium',
                        {
                            'text-[#9A9A9A]': !isPublished,
                            'text-[#4ACE8F]': isPublished,
                        }
                    )}
                    style={
                        isPublished
                            ? {
                                  border: '1px solid #4ACE8F',
                              }
                            : {
                                  border: '1px solid #9A9A9A',
                              }
                    }
                >
                    {isPublished ? 'Published' : 'Draft'}{' '}
                    {isPublished
                        ? detail?.hrPrivacyPolicy?.latestPublishVersion
                        : detail?.hrPrivacyPolicy?.version}
                </div>
                <span className="text-[#65707A]">
                    {
                        isPublished &&
                            `${t('Last published', { ns: 'consent' })} : ` +
                                `${detail?.hrPrivacyPolicy?.publishDate || '-'}`
                        // moment(previewData?.lastUpdate).format(
                        //     'DD/MM/YYYY HH:mm'
                        // )
                    }
                </span>
            </div>
        );
    };

    useEffect(() => {
        const getImage = async () => {
            try {
                const { data } = await GlobalService.getImageNoSecure(
                    hrPrivacyPolicy?.hrCompanyLogoId
                );
                if (data.resultData?.imageId) {
                    setLogo(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                } else {
                    setLogo('');
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (hrPrivacyPolicy?.hrCompanyLogoId) {
            getImage();
        } else {
            setLogo('');
        }
    }, [hrPrivacyPolicy]);

    // const isChange = props?.privacyNoticeId === 'new' ||
    //     !detail?.hrPrivacyPolicy?.isPublish ||
    //     detail?.hrPrivacyPolicy?.version ===
    //     detail?.hrPrivacyPolicy
    //         ?.latestPublishVersion

    let isChange = false;
    const version = detail?.hrPrivacyPolicy?.version || '0000.0';
    const parts = version?.split('.');

    const numberBehindDecimal = parseInt(parts[1]);
    const numberVersion = parseInt(parts[0]);
    if (parts && parts.length > 0) {
        if (numberVersion > 0) {
            if (numberBehindDecimal > 0) {
                isChange = true;
            }
        }
    }

    return (
        <Form name="preview" form={props?.form} initialValues={initial}>
            <Sticky stickyClassName="bg-white p-4 w-full z-50">
                <div className="flex px-4">
                    <div className="flex-1">
                        <div className="flex flex-col">
                            <div className="font-semibold text-2xl">
                                {t('policy.des8', { ns: 'translation' })}
                            </div>
                            <div className="text-[#9A9A9A]">
                                {statusSwitch(
                                    detail?.hrPrivacyPolicy?.status ===
                                        'Published'
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="flex space-x-4">
                        {isChange && (
                            <div className="text-xs text-right">
                                <div className="mb-1">
                                    {`${t('LastUpdate')} : ` +
                                        detail?.hrPrivacyPolicy?.updateDate}
                                </div>
                                <div>{`${t('Version')} : ${
                                    detail?.hrPrivacyPolicy?.version
                                }`}</div>
                                <div className="text-[#F0536F]">
                                    <span className="text-xl align-middle">
                                        &bull;
                                    </span>{' '}
                                    {t('Consent.DataChanged')}
                                </div>
                            </div>
                        )}
                        {((numberVersion === 0 && numberBehindDecimal > 0) ||
                            (numberVersion > 0 &&
                                numberBehindDecimal === 0)) && (
                            <div className="text-xs mt-[9px] text-[#65707A]">
                                <div className="mb-1">
                                    {`${t('LastUpdate')} : ` +
                                        `${
                                            detail?.hrPrivacyPolicy?.updateDate
                                                ? detail?.hrPrivacyPolicy
                                                      ?.updateDate
                                                : '-'
                                        }`}
                                </div>
                            </div>
                        )}
                        <Button
                            type="primary"
                            size="large"
                            loading={props.loading_}
                            // onClick={onPreviousStep}
                            onClick={() => props?.saveDraft()}
                            className="w-40"
                            ghost
                        >
                            {/* <ArrowLeftOutlined /> {t('policy.PreviousStep')} */}
                            {t('Save Draft')}
                        </Button>
                        <Button
                            // hidden={props.privacyNoticeId !== 'new'}
                            loading={props.loading_}
                            type="primary"
                            size="large"
                            onClick={() => {
                                setOpenConfirm(true);
                            }}
                        >
                            {/* {t('policy.Submit')} */}
                            {t('Save And Publish')}
                        </Button>
                    </div>
                </div>
            </Sticky>
            <Spin spinning={props.loading}>
                <div className="px-4">
                    <Divider />
                    <div className={`py-6 flex space-x-2 text-tiny -mt-4`}>
                        <span
                            style={{ borderRight: '1px solid #DBDBDB' }}
                            onClick={() => {
                                setPreviewLang('TH');
                            }}
                            className={`${
                                previewLang === 'TH'
                                    ? 'text-[#1890FF] font-semibold'
                                    : ''
                            } cursor-pointer hover:opacity-80 pr-2`}
                        >
                            {t('policy.th')}
                        </span>
                        <span
                            onClick={() => {
                                setPreviewLang('EN');
                            }}
                            className={`${
                                previewLang === 'EN'
                                    ? 'text-[#1890FF] font-semibold'
                                    : ''
                            } cursor-pointer hover:opacity-80`}
                        >
                            {t('policy.en')}
                        </span>
                    </div>
                    {/* Step 1 */}
                    {/* Step 1 */}
                    {/* Step 1 */}
                    {/* Step 1 */}
                    {/* Step 1 */}
                    <div className="flex justify-between items-center bg-[#F4F6FC] text-[#7B67FB] p-3">
                        <div className="font-semibold text-base">
                            {previewLang === 'TH'
                                ? 'กำหนดชื่อนโยบายและข้อมูลองค์กร'
                                : 'Define the policy name and organization information'}
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                                // navigate(`${ROUTER.POLICY.HR_PRIVACY}/${hrPrivacyPolicy?.hrPrivacyPolicyId}#step1`);
                                // props.setCurrentSelectList(1)
                                props.goToStep(1);
                                props.calProgress(1);
                            }}
                        >
                            {IconEdit}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="font-semibold text-sm">
                            {previewLang === 'TH'
                                ? 'นโยบายความเป็นส่วนตัวสำหรับฝ่ายทรัพยากรบุคคล'
                                : 'Name of HR Privacy Policy'}
                        </div>
                        <div className="text-[#65707A]">
                            {previewLang === 'TH'
                                ? hrPrivacyPolicy?.hrPrivacyPolicyNameTh || '-'
                                : hrPrivacyPolicy?.hrPrivacyPolicyNameEn || '-'}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="font-semibold text-sm">
                            {previewLang === 'TH'
                                ? 'ฉบับ ณ วันที่'
                                : 'Updated as of'}
                        </div>
                        <div className="text-[#65707A]">
                            {previewLang === 'TH'
                                ? hrPrivacyPolicy?.hrEffectiveDate || '-'
                                : hrPrivacyPolicy?.hrEffectiveDate || '-'}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="font-semibold text-sm">
                            {previewLang === 'TH'
                                ? 'ชื่อองค์กร (หรือชื่อบุคคลเจ้าของ)'
                                : 'Organization name (or Owner Name)'}
                        </div>
                        <div className="text-[#65707A]">
                            {previewLang === 'TH'
                                ? hrPrivacyPolicy?.hrCompanyNameTh || '-'
                                : hrPrivacyPolicy?.hrCompanyNameEn || '-'}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="font-semibold text-sm">
                            {previewLang === 'TH' ? 'โลโก้องค์กร' : 'Logo'}
                        </div>
                        <div className="text-[#65707A]">
                            {/* {hrPrivacyPolicy?.hrCompanyLogoId && (
                            <img
                                className="w-20 object-cover my-0"
                                src={logo}
                                alt={
                                    previewLang === 'TH'
                                        ? hrPrivacyPolicy?.hrCompanyNameTh
                                        : hrPrivacyPolicy?.hrCompanyNameEn
                                }
                            />
                        )} */}
                            {logo ? (
                                // eslint-disable-next-line jsx-a11y/img-redundant-alt
                                <img
                                    className="w-auto h-16 rounded-lg object-cover"
                                    style={{
                                        border: '1px solid #DBDBDB',
                                    }}
                                    src={logo}
                                    alt="image"
                                />
                            ) : (
                                svgNoImage
                            )}
                        </div>
                    </div>
                    <div className="py-4 leading-8">
                        <div className="font-semibold text-sm">
                            {previewLang === 'TH'
                                ? 'นโยบายนี้ใช้กับเจ้าของข้อมูลประเภทใด'
                                : 'Which type of data subject does this policy apply to'}
                        </div>
                        <div className="text-[#65707A]">
                            {hrPrivacyPolicy?.hrPrivacyPolicyDataSubjectType
                                ?.map((e) =>
                                    previewLang === 'TH'
                                        ? e?.hrDataSubjectNameTh || '-'
                                        : e?.hrDataSubjectNameEn || '-'
                                )
                                .toString()}
                        </div>
                    </div>
                    {/* Step 2 */}
                    {/* Step 2 */}
                    {/* Step 2 */}
                    {/* Step 2 */}
                    {/* Step 2 */}
                    <div className="flex justify-between items-center bg-[#F4F6FC] text-[#7B67FB] p-3">
                        <div className="font-semibold text-base">
                            {previewLang === 'TH'
                                ? 'บทนำและฐานกฎหมาย'
                                : 'Introduction and Lawful Basis'}
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                                props.goToStep(2);
                                props.calProgress(2);
                            }}
                        >
                            {IconEdit}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrIntroductionLawfulBasis?.hrIntroductionTitleTh ||
                                          '-'
                                        : hrIntroductionLawfulBasis?.hrIntroductionTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrIntroductionLawfulBasis?.hrIntroductionContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrIntroductionLawfulBasis?.hrIntroductionContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrIntroductionIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="py-4 leading-8">
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrIntroductionLawfulBasis?.hrLawfulBasisTitleTh ||
                                          '-'
                                        : hrIntroductionLawfulBasis?.hrLawfulBasisTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrIntroductionLawfulBasis?.hrLawfulBasisContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrIntroductionLawfulBasis?.hrLawfulBasisContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrLawfulBasisIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Step 3 */}
                    {/* Step 3 */}
                    {/* Step 3 */}
                    {/* Step 3 */}
                    {/* Step 3 */}
                    <div className="flex justify-between items-center bg-[#F4F6FC] text-[#7B67FB] p-3">
                        <div className="font-semibold text-base">
                            {previewLang === 'TH'
                                ? 'ข้อมูลส่วนบุคคลที่เก็บรวบรวมและแหล่งที่มา'
                                : 'Personal data collected and used'}
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                                props.goToStep(3);
                                props.calProgress(3);
                            }}
                        >
                            {IconEdit}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrPersonalDataCollect?.hrPersonalDataTitleTh ||
                                          '-'
                                        : hrPersonalDataCollect?.hrPersonalDataTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrPersonalDataCollect?.hrPersonalDataContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrPersonalDataCollect?.hrPersonalDataContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrPersonalDataIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="py-4 leading-8">
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrPersonalDataCollect?.hrSourceTitleTh ||
                                          '-'
                                        : hrPersonalDataCollect?.hrSourceTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrPersonalDataCollect?.hrSourceContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrPersonalDataCollect?.hrSourceContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrSourceIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Step 4 */}
                    {/* Step 4 */}
                    {/* Step 4 */}
                    {/* Step 4 */}
                    {/* Step 4 */}
                    <div className="flex justify-between items-center bg-[#F4F6FC] text-[#7B67FB] p-3">
                        <div className="font-semibold text-base">
                            {previewLang === 'TH'
                                ? 'เหตุผลในการเก็บรวบรวมข้อมูล'
                                : 'Reason for collected data'}
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                                props.goToStep(4);
                                props.calProgress(4);
                            }}
                        >
                            {IconEdit}
                        </div>
                    </div>
                    <div className="py-4 leading-8">
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrReasonCollectedData?.hrPurposeTitleTh ||
                                          '-'
                                        : hrReasonCollectedData?.hrPurposeTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrReasonCollectedData?.hrPurposeContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrReasonCollectedData?.hrPurposeContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrPurposeIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Step 5 */}
                    {/* Step 5 */}
                    {/* Step 5 */}
                    {/* Step 5 */}
                    {/* Step 5 */}
                    <div className="flex justify-between items-center bg-[#F4F6FC] text-[#7B67FB] p-3">
                        <div className="font-semibold text-base">
                            {previewLang === 'TH'
                                ? 'บุคคลใดที่เราจะเปิดเผยหรือโอนข้อมูลส่วนบุคคล'
                                : 'Who we will disclose or transfer personal data'}
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                                props.goToStep(5);
                                props.calProgress(5);
                            }}
                        >
                            {IconEdit}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrTransferPersonalData?.hrDisclosureTitleTh ||
                                          '-'
                                        : hrTransferPersonalData?.hrDisclosureTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrTransferPersonalData?.hrDisclosureContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrTransferPersonalData?.hrDisclosureContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrDisclosureIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="py-4 leading-8">
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrTransferPersonalData?.hrInternationalTitleTh ||
                                          '-'
                                        : hrTransferPersonalData?.hrInternationalTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrTransferPersonalData?.hrInternationalContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrTransferPersonalData?.hrInternationalContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrInternationalIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Step 6 */}
                    {/* Step 6 */}
                    {/* Step 6 */}
                    {/* Step 6 */}
                    {/* Step 6 */}
                    <div className="flex justify-between items-center bg-[#F4F6FC] text-[#7B67FB] p-3">
                        <div className="font-semibold text-base">
                            {previewLang === 'TH'
                                ? 'รักษาข้อมูลส่วนบุคคลไว้นานเท่าใดและเก็บรักษาข้อมูลอย่างไร'
                                : 'How long and how we retain personal data?'}
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                                props.goToStep(6);
                                props.calProgress(6);
                            }}
                        >
                            {IconEdit}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrRetainPersonalData?.hrRetentionTitleTh ||
                                          '-'
                                        : hrRetainPersonalData?.hrRetentionTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrRetainPersonalData?.hrRetentionContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrRetainPersonalData?.hrRetentionContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrRetentionIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="py-4 leading-8">
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrRetainPersonalData?.hrSecurityTitleTh ||
                                          '-'
                                        : hrRetainPersonalData?.hrSecurityTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrRetainPersonalData?.hrSecurityContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrRetainPersonalData?.hrSecurityContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrSecurityIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Step 7 */}
                    {/* Step 7 */}
                    {/* Step 7 */}
                    {/* Step 7 */}
                    {/* Step 7 */}
                    <div className="flex justify-between items-center bg-[#F4F6FC] text-[#7B67FB] p-3">
                        <div className="font-semibold text-base">
                            {previewLang === 'TH'
                                ? 'สิทธิของเจ้าของข้อมูล'
                                : 'Data Subject Rights'}
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                                props.goToStep(7);
                                props.calProgress(7);
                            }}
                        >
                            {IconEdit}
                        </div>
                    </div>
                    <div className="py-4 leading-8">
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrDataSubjectRight?.hrDataSubjectRightTitleTh ||
                                          '-'
                                        : hrDataSubjectRight?.hrDataSubjectRightTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrDataSubjectRight?.hrDataSubjectRightContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrDataSubjectRight?.hrDataSubjectRightContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrDataSubjectRightIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Step 8 */}
                    {/* Step 8 */}
                    {/* Step 8 */}
                    {/* Step 8 */}
                    {/* Step 8 */}
                    <div className="flex justify-between items-center bg-[#F4F6FC] text-[#7B67FB] p-3">
                        <div className="font-semibold text-base">
                            {previewLang === 'TH'
                                ? 'การเปลี่ยนแปลงนโยบาย และช่องทางการติดต่อ'
                                : 'Policy change and contact channels'}
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                                props.goToStep(8);
                                props.calProgress(8);
                            }}
                        >
                            {IconEdit}
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrPolicyChange?.hrChangeTitleTh || '-'
                                        : hrPolicyChange?.hrChangeTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrPolicyChange?.hrChangeContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrPolicyChange?.hrChangeContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrChangeIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="py-4 leading-8"
                        style={{ borderBottom: '2px dashed #DBDBDB' }}
                    >
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrPolicyChange?.hrDataControllerTitleTh ||
                                          '-'
                                        : hrPolicyChange?.hrDataControllerTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrPolicyChange?.hrDataControllerContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrPolicyChange?.hrDataControllerContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrDataControllerIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="py-4 leading-8">
                        <div className="flex justify-between">
                            <div className="basis-[88.5%]">
                                <div className="font-semibold text-sm">
                                    {previewLang === 'TH'
                                        ? hrPolicyChange?.hrDataProtectionTitleTh ||
                                          '-'
                                        : hrPolicyChange?.hrDataProtectionTitleEn ||
                                          '-'}
                                </div>
                                <div className="text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? parse(
                                              hrPolicyChange?.hrDataProtectionContentTh ||
                                                  '-'
                                          )
                                        : parse(
                                              hrPolicyChange?.hrDataProtectionContentEn ||
                                                  '-'
                                          )}
                                </div>
                            </div>
                            <div className="basis-[11.5%] flex items-top text-right justify-end space-x-2">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {previewLang === 'TH'
                                        ? 'แสดงข้อมูล'
                                        : 'Show data'}
                                </div>
                                <div>
                                    <Form.Item
                                        name="hrDataProtectionIsDisplay"
                                        valuePropName="checked"
                                    >
                                        <Switch defaultChecked />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Spin>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
            <ModalConfirm
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                loading={props.loading_}
                handelOk={() => {
                    props?.onFormFinish('', {
                        values: props?.form?.getFieldsValue(),
                    });
                }}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            {t('Publish this policy')}
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            {t('Consent.PublishedVersion')}:{' '}
                            {hrPrivacyPolicy?.latestPublishVersion
                                ? getNextVersion()
                                : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
        </Form>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

const IconEdit = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.988 2.01221L21.988 5.01221L19.701 7.30021L16.701 4.30021L18.988 2.01221ZM8 16.0002H11L18.287 8.71321L15.287 5.71321L8 13.0002V16.0002Z"
            fill="#7B67FB"
        />
        <path
            d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
            fill="#7B67FB"
        />
    </svg>
);

const initial = {
    hrChangeIsDisplay: true,
    hrDataControllerIsDisplay: true,
    hrDataProtectionIsDisplay: true,
    hrDataSubjectRightIsDisplay: true,
    hrDisclosureIsDisplay: true,
    hrInternationalIsDisplay: true,
    hrIntroductionIsDisplay: true,
    hrLawfulBasisIsDisplay: true,
    hrPersonalDataIsDisplay: true,
    hrPurposeIsDisplay: true,
    hrRetentionIsDisplay: true,
    hrSecurityIsDisplay: true,
    hrSourceIsDisplay: true,
};
